import { SelectionBulkOverlay } from '@pages/ConfiguredEntity/context'

export const resolveRowSelectionChecked = (
  bulkSelectionOverlay: SelectionBulkOverlay,
  selectedRowIdsSet: ReadonlySet<string>,
  rowId: string
) => {
  if (bulkSelectionOverlay === 'select-all') {
    return true
  }

  if (bulkSelectionOverlay === 'clear-all') {
    return false
  }

  return selectedRowIdsSet.has(rowId)
}

export const resolveSelectAllCheckboxChecked = (
  bulkSelectionOverlay: SelectionBulkOverlay,
  isSelectAllCheckbox: boolean
) => {
  if (bulkSelectionOverlay === 'select-all') {
    return true
  }

  if (bulkSelectionOverlay === 'clear-all') {
    return false
  }

  return isSelectAllCheckbox
}
